"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'FloatingBottomMenu_1_0_0',
  label: 'Quick links',
  ctas: [{
    label: 'Special Offers',
    link: '/en/configure-your-mitsubishi/configurator',
    linkOriginal: '/content/mitsubishi-motors/us/en/configure-your-mitsubishi/configurator',
    ctaAlignment: 'right',
    openNewTab: false,
    icon: 'Brochure',
    priority: 'lowIcon',
    customImage: ''
  }, {
    label: 'Find a Dealer',
    link: '/en/configure-your-mitsubishi/configurator',
    linkOriginal: '/content/mitsubishi-motors/us/en/configure-your-mitsubishi/configurator',
    ctaAlignment: 'right',
    openNewTab: false,
    icon: 'Address',
    priority: 'lowIcon',
    customImage: ''
  }, {
    label: 'Request a Quote',
    link: '/en/configure-your-mitsubishi/configurator',
    linkOriginal: '/content/mitsubishi-motors/us/en/configure-your-mitsubishi/configurator',
    ctaAlignment: 'right',
    openNewTab: false,
    icon: 'PressKit',
    priority: 'lowIcon',
    customImage: ''
  }]
};
var _default = exports["default"] = DEFAULT_PROPS;